export default {
  'manufacturers.general.form.description': 'Descrição do fabricante',
  'manufacturers.general.form.deleteButton': 'Remover',
  'manufacturers.general.form.okButton': 'Salvar',
  'manufacturers.modal.create.title': 'Adicionar fabricante',
  'manufacturers.modal.create.messageSuccess': 'Atualizado com sucesso!',
  'manufacturers.modal.edit.title': 'Editar fabricante',
  'manufacturers.modal.edit.messageSuccess': 'Cadastrado com sucesso!',
  'manufacturers.modal.messageError': 'Não foi possível salvar a ação!',
  'manufacturers.page.title': 'Fabricante',
  'manufacturers.page.button.generateReport': 'Gerar relatório',
  'manufacturers.page.button.newManufacturer': 'Novo fabricante',
  'manufacturers.list.header.description': 'Descrição do fabricante',
  'manufacturers.list.header.manufacturerCode': 'Cód. fabricante',
  'manufacturers.list.header.added': 'Adicionado',
  'manufacturers.list.header.action': 'Ação',

  'manufacturers.modal.status.disable.title': 'Desativar fabricante',
  'manufacturers.modal.status.disable.description':
    'Deseja desativar o fabricante',
  'manufacturers.modal.status.enable.title': 'Ativar fabricante',
  'manufacturers.modal.status.enable.description': 'Deseja ativar o fabricante',

  'manufacturers.modal.report.form.description': 'Descrição',
  'manufacturers.modal.report.title': 'Gerar Relatório',
  'manufacturers.modal.report.buttons.viewReport': 'Visualizar Relatório',
  'manufacturers.modal.report.buttons.pdf': 'Gerar PDF',
  'manufacturers.modal.report.buttons.rtf': 'Gerar RTF',
  'manufacturers.modal.report.buttons.csv': 'Gerar CSV',
  'manufacturers.notification.generate.report.title':
    'Relatório gerado com sucesso',
  'manufacturers.notification.generate.report.description':
    'Relatório de Fabricante Gerado com Sucesso!',
};
